export default "__VITE_ASSET__33bd7d5a__"